import { CLEAR_MODAL } from 'root/src/client/logic/static/actionIds'

export default () => ({
	type: CLEAR_MODAL,
})
